/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Amount_SelectInputs */

const en_support_amount_select = /** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Contribution Level`)
};

const es_support_amount_select = /** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona el Nivel de Contribución`)
};

const fr_support_amount_select = /** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le niveau de contribution`)
};

const de_support_amount_select = /** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitragshöhe auswählen`)
};

const id_support_amount_select = /** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih Tingkat Kontribusi`)
};

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const ja_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const zh_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const ar_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const it_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const ru_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const pt_support_amount_select = en_support_amount_select;

/** @type {(inputs: Support_Amount_SelectInputs) => LocalizedString} */
const ko_support_amount_select = en_support_amount_select;

/**
* | output |
* | --- |
* | "Select Contribution Level" |
*
* @param {Support_Amount_SelectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_amount_select = /** @type {((inputs?: Support_Amount_SelectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Amount_SelectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_amount_select(inputs)
	if (locale === "es") return es_support_amount_select(inputs)
	if (locale === "fr") return fr_support_amount_select(inputs)
	if (locale === "de") return de_support_amount_select(inputs)
	if (locale === "ja") return ja_support_amount_select(inputs)
	if (locale === "zh") return zh_support_amount_select(inputs)
	if (locale === "ar") return ar_support_amount_select(inputs)
	if (locale === "id") return id_support_amount_select(inputs)
	if (locale === "it") return it_support_amount_select(inputs)
	if (locale === "ru") return ru_support_amount_select(inputs)
	if (locale === "pt") return pt_support_amount_select(inputs)
	return ko_support_amount_select(inputs)
});